import type { ReactElement } from "react";

import { translate } from "app/filters/i18nFilter";
import { StyledZipCodeContainer } from "app/pages/sales-intelligence/common-components/zip-codes/components/ZipCodeInput/styles";
import ZipCodesBulkAdd from "app/pages/sales-intelligence/common-components/zip-codes/components/ZipCodesBulkAdd/ZipCodesBulkAdd";
import normalizeZipCode from "app/pages/sales-intelligence/common-components/zip-codes/utils/normalizeZipCode";
import InteractiveTextInput from "app/pages/sales-intelligence/sub-modules/advanced-search/components/shared/InteractiveTextInput/InteractiveTextInput";

interface IZipCodeInputProps {
    placeholderTranslation: string;
    bulkTranslationPrefix: string;
    onAdd: (code: string) => void;
    onBulkAdd: (codes: string[]) => void;
}

export const ZipCodeInput = ({
    placeholderTranslation,
    bulkTranslationPrefix,
    onAdd,
    onBulkAdd,
}: IZipCodeInputProps): ReactElement => (
    <StyledZipCodeContainer data-automation="headquarters-postal-code">
        <InteractiveTextInput
            placeholder={translate(placeholderTranslation)}
            dataAutomation="headquarters-postal-code-input"
            onAdd={onAdd}
            iconName="location"
            transformValue={normalizeZipCode}
        />
        <ZipCodesBulkAdd
            translationPrefix={bulkTranslationPrefix}
            onUpdate={onBulkAdd}
        />
    </StyledZipCodeContainer>
);
